import { AirQualityStationType } from "@/db/definitions";
import { Building2, Car, Factory, Gauge, LucideIcon, Wind } from "lucide-react";
import React from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  type: AirQualityStationType;
  className?: string;
};

const iconMap: Record<AirQualityStationType, LucideIcon> = {
  REGIONAL: Wind,
  MUNICIPAL: Building2,
  TRAFFIC: Car,
  INDUSTRIAL: Factory,
  OTHER: Gauge,
};
const IconAirStation: React.FC<Props> = ({ type, className }) => {
  const Icon = iconMap[type];
  return <Icon className={twMerge("w-5 h-5", className)} />;
};

export default IconAirStation;
